import * as subscriptionList  from './subscriptionList'
import * as subscribedList  from './subscribedList'

export default {
    ...subscriptionList,
    ...subscribedList
} 